import { Injectable, inject } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { OrganisationService } from "@sdk/lib/services/organisation.service";
import { PatientProfile } from "@sdk/lib/types/profile";
import { environment } from "../../../environments/environment";

@Injectable({ providedIn: "root" })
export class StagingRedirectService {
  private readonly _auth = inject(AuthService);
  private readonly _organisationService = inject(OrganisationService);
  private readonly _liveLoginUrl = "https://user.mindlife.app/login";
  private _organisationConfirmed = false;

  isStagingHost(hostname: string = window.location.hostname, production: boolean = environment.production): boolean {
    return !production && hostname !== "localhost";
  }

  keepOnThisEnvironment(profile: PatientProfile): Observable<boolean> {
    const organisationId = profile?.assigned_organisation_id;
    if (this._organisationConfirmed || !organisationId || !this.isStagingHost()) {
      return of(true);
    }
    return this._organisationService.getOrganisationById(String(organisationId)).pipe(
      map((organisation) => {
        if (organisation) {
          this._organisationConfirmed = true;
          return true;
        }
        this._leaveForLive(profile.email);
        return false;
      }),
      catchError(() => of(true)),
    );
  }

  private _leaveForLive(email: string | undefined): void {
    const target = `${this._liveLoginUrl}?${email ? `email=${encodeURIComponent(email)}&` : ""}bypass_disclaimer=true`;
    this._auth.logout({ openUrl: false }).subscribe({
      complete: () => this.navigateTo(target),
      error: () => this.navigateTo(target),
    });
  }

  navigateTo(url: string): void {
    window.location.href = url;
  }
}
